.features-container {
  display: inline-flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  padding-bottom: 48px;
  /* background: #5e686e; */
  background: var(--ion-color-primary);
  padding: 24px 0px;
  box-shadow: inset 0px 6px 12px rgba(46, 61, 73, .4),
    inset 0px -6px 12px rgba(46, 61, 73, .4);
}

.features-block {
  position: relative;
  width: 90vw;
  max-width: 1000px;
  height: auto;
  margin: 24px 4px 48px 4px;

  display: inline-flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.features-left-block {
  position: relative;
  width: 50vw;
  max-width: 500px;
  height: auto;
  padding: 0px 4px;
  min-height: 325px;
}

.features-right-block {
  position: relative;
  width: 50vw;
  max-width: 500px;
  height: auto;
  padding: 8px 4px;
  min-height: 325px;

  /* display: inline-flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center; */
}

@media only screen and (max-width: 800px) {
  .features-right-block {
    min-width: 88vw;
  }
}

.features-header {
  --color: #ddd;
  margin: 2px 0px;
}

.feature-expander-item {
  /* --background: #c8cdea !important; */
}

.feature-content {
  text-align: justify;
  padding: 16px 8px;
}

.feature-image {
  width: 80vw;
  max-width: 320px !important;
  /* max-height: 380px !important; */
}

.feature-icon-1 {
  margin-right: 14px;
}

.small-padding-bottom {
  padding-bottom: 8px;
}

.shadow {
  box-sizing: 2px 2px rgba(0,0,0, 0.25);
}